import { motion, useInView } from "framer-motion";
import { useRef } from "react";
import { Button } from "./ui/button";
import { Link } from "react-router-dom";
import gmailIcon from "@/assets/gmail.svg";
import teamsIcon from "@/assets/teams.svg";
import slackIcon from "@/assets/slack.svg";
import instagramIcon from "@/assets/instagram.svg";
import messengerIcon from "@/assets/messenger.svg";

import outlookIcon from "@/assets/outlook.svg";

export const FinalCTASection = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  return (
    <section className="py-24 relative overflow-hidden">
      <div className="absolute inset-0 bg-[#0A0F1C]" />
      <div className="absolute inset-0 noise-texture opacity-20" />

      <div className="container relative z-10" ref={ref}>
        <motion.div
          className="text-center max-w-2xl mx-auto"
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
        >
          <h2 className="heading-lg mb-4">Stop letting your inbox run your life.</h2>
          <p className="body-lg text-muted-foreground mb-10">
            Join smart executives who save 10+ hours a week with ClearMakes. No credit card required to start.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-14">
            <Button variant="hero" size="lg" asChild className="text-lg px-8 py-6">
              <Link to="/pricing">Choose a Plan</Link>
            </Button>
            <Link
              to="/contact"
              className="text-primary hover:text-primary/80 font-medium text-sm underline underline-offset-4"
            >
              View Enterprise Plans
            </Link>
          </div>

          {/* Trust footer */}
          <motion.div
            className="flex flex-col items-center gap-4 text-sm text-muted-foreground"
            initial={{ opacity: 0 }}
            animate={isInView ? { opacity: 1 } : {}}
            transition={{ duration: 0.5, delay: 0.3 }}
          >
            <p className="text-xs uppercase tracking-widest text-muted-foreground/80">Works with</p>
            <div className="flex items-center gap-6 flex-wrap justify-center">
              <img src={gmailIcon} alt="Gmail" className="w-8 h-8 object-contain opacity-70" />
              <img src={outlookIcon} alt="Outlook" className="w-8 h-8 object-contain opacity-70" />
              <img src={teamsIcon} alt="Teams" className="w-8 h-8 object-contain opacity-70" />
              <img src={slackIcon} alt="Slack" className="w-8 h-8 object-contain opacity-70" />
              <img src={instagramIcon} alt="Instagram" className="w-8 h-8 object-contain opacity-70" />
              <img src={messengerIcon} alt="Messenger" className="w-8 h-8 object-contain opacity-70" />
            </div>
            <p className="text-xs text-muted-foreground/90">Cancel anytime. No hidden fees.</p>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};
